import { h, Host } from "@stencil/core";
export class SliderHorizontal {
    constructor() {
        this.open = false;
        this.slides = [];
        this.visibleSlides = [];
        this.numberOfSlides = 3;
        this.index = 0;
    }
    componentWillLoad() {
        this.slides = Array.from(this.el.querySelectorAll('.carousel-horizontal-item'));
        this.slides.forEach((item, i) => {
            if (i === this.index) {
                this.setActive(item);
            }
            if (i < this.numberOfSlides) {
                this.visibleSlides.push(item);
                this.setHidden(item, false);
            }
            if (i >= this.numberOfSlides) {
                this.setHidden(item, true);
            }
            item.addEventListener('click', () => this.setActive(item));
        });
    }
    onClickedSlider(ev) {
        this.activeItem = ev.detail;
    }
    setActive(item) {
        this.slides.forEach((item) => item.classList.remove('active'));
        this.activeItem = item;
        item.classList.add('active');
    }
    setHidden(item, hide) {
        if (hide) {
            item.setAttribute('hidden', 'hidden');
        }
        else {
            item.removeAttribute('hidden');
        }
    }
    prev(event) {
        event.preventDefault();
        var newIndex = this.index - 1 < 0 ? this.slides.length - 1 : this.index - 1;
        this.select(this.slides[newIndex]);
        this.setActive(this.slides[newIndex]);
        this.calculateSlides();
    }
    next(event) {
        event.preventDefault();
        var newIndex = (this.index + 1) % this.slides.length;
        this.select(this.slides[newIndex]);
        this.setActive(this.slides[newIndex]);
        this.calculateSlides();
    }
    select(item) {
        this.activeItem = item;
        this.index = this.slides.indexOf(item);
    }
    toggleAll() {
        this.numberOfSlides = this.numberOfSlides === 3 ? this.slides.length : 3;
        this.calculateSlides();
        this.open = this.visibleSlides.length === this.slides.length;
    }
    ;
    calculateSlides() {
        var visibleSlides = [];
        this.slides.forEach((item, slideIndex) => {
            if (this.numberOfSlides === this.slides.length) {
                visibleSlides.push(item);
                return;
            }
            if (slideIndex >= this.index && slideIndex < (this.index + this.numberOfSlides)) {
                visibleSlides.push(item);
            }
        });
        if (visibleSlides.length !== this.numberOfSlides && this.slides.length > this.numberOfSlides) {
            this.slides.forEach((item) => {
                if (visibleSlides.length !== this.numberOfSlides) {
                    visibleSlides.push(item);
                }
            });
        }
        this.visibleSlides = visibleSlides;
        this.slides.forEach((item) => {
            if (this.visibleSlides.indexOf(item) !== -1) {
                this.setHidden(item, false);
            }
            else {
                this.setHidden(item, true);
            }
        });
    }
    ;
    render() {
        return (h(Host, { key: 'e5e96c1b4efa8746ae3d4023f9ce0771c3ef6101' }, h("div", { key: 'd207f5cee752c1bcd5312832f5329333ff608c8e', class: "carousel-horizontal-content", innerHTML: this.activeItem.innerHTML }), h("div", { key: '01275eedd92e1aeb802bb7bda9d2c176e66a3fef', class: "carousel-horizontal-control" }, h("slot", { key: '91015ad4c543b3c891298461902bf7029fa0a708' }), h("a", { key: '84dccd0b04bc1f411f6f67a0fcf80880d4944973', class: "carousel-control invert small top", role: "button", hidden: this.slides.length <= 3, onClick: (event) => this.prev(event) }), h("a", { key: 'bed5ea7623e99bae5a3d97a364d8f5ec7861919b', class: "carousel-control invert small bottom", role: "button", hidden: this.slides.length <= 3, onClick: (event) => this.next(event) }), h("div", { key: '7fcda75a435cb3a527ae5b3bf834453626508276', class: "text-xs-center hidden-md-up", hidden: this.slides.length <= 3 }, h("a", { key: '8b5a1fad8882aab3f84035765036a7894ff574ad', class: "btn btn-link btn-lg icon-left", onClick: _ => this.toggleAll() }, h("svg", { key: '6997e338363c56fe5c4d3eaa9c3b52911e08c45b', width: "32", height: "32" }, this.open ? h("use", { href: "#fa-minus-circle" }) : h("use", { href: "#fa-plus-circle" })), h("span", { key: '49f09ddf4a5f59a21d9dc82fb2cc5bd762d4a9a4' }, this.open ? this.labelClose : this.labelOpen))))));
    }
    ;
    static get is() { return "uvex-slider-horizontal"; }
    static get properties() {
        return {
            "labelOpen": {
                "type": "string",
                "attribute": "label-open",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "labelClose": {
                "type": "string",
                "attribute": "label-close",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "activeItem": {},
            "open": {}
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=slider-horizontal.js.map
